<template>
  <el-dialog
    :model-value="visible"
    :title="form.Codigo ? 'Editar Color' : 'Nuevo Color'"
    width="500px"
    @update:model-value="$emit('update:visible', $event)"
    @close="resetForm"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      label-position="top"
    >
      <el-form-item prop="Descripcion">
        <custom-input
          :model-value="form.Descripcion"
          label="Descripción"
          :spanColumn="24"
          :settings="{ placeholder: 'Ej: Azul Reflex' }"
          @update:model-value="updateField('Descripcion', $event)"
        />
      </el-form-item>

      <el-form-item prop="Pantone">
        <custom-input
          :model-value="form.Pantone"
          label="Pantone"
          :spanColumn="24"
          :settings="{ placeholder: 'Ej: Reflex Blue C' }"
          @update:model-value="updateField('Pantone', $event)"
        />
      </el-form-item>

      <el-form-item prop="Hex">
        <div class="hex-field">
          <custom-input
            :model-value="form.Hex"
            label="Hex"
            :spanColumn="24"
            class="hex-input"
            :settings="{ placeholder: '#000000', maxlength: 7 }"
            @update:model-value="updateField('Hex', $event)"
          />
          <div class="hex-picker-wrapper">
            <span
              class="hex-preview"
              :style="{ backgroundColor: isValidHex(form.Hex) ? form.Hex : '#ffffff' }"
            />
            <el-color-picker
              :model-value="form.Hex"
              :predefine="predefineColors"
              :show-alpha="false"
              size="large"
              class="hex-picker"
              @update:model-value="updateField('Hex', $event)"
            />
          </div>
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <el-button @click="$emit('update:visible', false)">Cancelar</el-button>
      <el-button
        type="primary"
        :loading="saving"
        @click="handleSave"
      >
        Guardar
      </el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import {
  ref,
  watch,
} from 'vue';
import CustomInput from '@/shared/components/custom_input.vue';

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
  form: {
    type: Object,
    required: true,
  },
  saving: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:visible', 'save', 'update:form']);

const formRef = ref(null);

const HEX_PATTERN = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/;

const predefineColors = [
  '#000000',
  '#FFFFFF',
  '#FF0000',
  '#F5A623',
  '#F8E71C',
  '#7ED321',
  '#417505',
  '#50E3C2',
  '#4A90E2',
  '#9013FE',
  '#BD10E0',
  '#9B9B9B',
];

const rules = {
  Descripcion: [{ required: true, message: 'La descripción es requerida', trigger: 'blur' }],
  Hex: [
    { required: true, message: 'El color es requerido', trigger: 'change' },
    {
      pattern: HEX_PATTERN,
      message: 'Hex inválido, ej: #001E62',
      trigger: 'blur',
    },
  ],
};

function isValidHex(value) {
  return HEX_PATTERN.test(value || '');
}

function updateField(field, value) {
  emit('update:form', { ...props.form, [field]: value });
}

function resetForm() {
  formRef.value?.clearValidate();
}

async function handleSave() {
  try {
    await formRef.value.validate();
    emit('save');
  } catch (error) {
    // Error de validación
  }
}

watch(
  () => props.visible,
  (newVal) => {
    if (!newVal) {
      resetForm();
    }
  },
);
</script>

<style scoped>
.hex-field {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}
.hex-input {
  flex: 1;
}
.hex-picker-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 2px;
}
.hex-preview {
  display: inline-block;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid var(--el-border-color);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04) inset;
}
.hex-picker :deep(.el-color-picker__trigger) {
  width: 40px;
  height: 40px;
  padding: 4px;
}
</style>

<style>
.el-color-dropdown__btns {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
}
.el-color-dropdown__link-btn {
  color: var(--el-color-danger);
  font-weight: 600;
}
.el-color-dropdown__link-btn:hover {
  color: var(--el-color-danger-light-3);
}
.el-color-dropdown__btn {
  padding: 6px 18px;
  font-weight: 600;
  border-radius: 4px;
}
</style>
